













import { mapState } from 'vuex';
import { Vue, Component } from 'vue-property-decorator';

import * as ROUTES from '@/constants/routes';

@Component({
  computed: mapState('user', ['userInfo'])
})
export default class TopBar extends Vue {
  public userInfo!: any;

  private beforeMount() {
    this.$store.dispatch('user/fetchUserInfo');
  }

  private handleLogOut(e: any) {
    e.preventDefault();

    this.$store.dispatch('user/logout').then(() => {
      this.$router.push(ROUTES.LOGIN);
    });
  }

  get hasProfilePictureUrl() {
    return !!this.userInfo.profilePictureUrl;
  }
}
